import Logo from '../components/logo';
import check from '../check.svg';
import { useParams, useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import { STORAGE_KEYS } from '../config';

function CheckedInPage() {
  const { companyId } = useParams();
  const [counter, setCounter] = useState(15);
  const [service, setService] = useState('');
  const [companyName, setCompanyName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const selectedService = window.sessionStorage.getItem(STORAGE_KEYS.SELECTED_SERVICE);
    const currentCompanyName = window.localStorage.getItem(STORAGE_KEYS.COMPANY_NAME);

    setService(selectedService!);
    setCompanyName(currentCompanyName!);
  }, []);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | number = 0;
    if (counter > 0) {
      timeoutId = setTimeout(() => setCounter((value) => value - 1), 1000);
    }
    if (counter === 0) {
      clearTimeout(timeoutId);
      navigate(`/${companyId}`);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [counter, companyId, navigate]);

  return (
    <div className='flex justify-center flex-col items-center'>
      <Logo companyId={companyId!}></Logo>

      <img src={check} className='w-1/4 md:w-1/6 mb-10 mt-10' alt='CheckN Logo' />

      <div className='text-center mx-10'>
        <p className='text-5xl font-semibold text-[#5C9B0A] mb-20'>
          You're all
          <br /> checked in!
        </p>
        <p className='text-3xl mb-14'>
          Your request was sent to {companyName} for {service}.
        </p>
        <p className='text-3xl mb-14'>
          You will be receiving a text message soon. Reply directly on that text.
        </p>
      </div>
    </div>
  );
}

export default CheckedInPage;
